import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faEnvelope,
  faKey,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Stilovi za toast
import API from "../../utils/api"; // Uvozimo API instancu
import "./Register.css";

const Register = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // Navigacija nakon uspešne registracije

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !email || !password || !confirmPassword) {
      toast.error("Sva polja su obavezna!");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Lozinke se ne poklapaju!");
      return;
    }

    try {
      setLoading(true);

      // 🟢 Axios API poziv
      const { data } = await API.post("/auth/register", {
        username,
        email,
        password,
      });

      toast.success("Uspešno ste se registrovali!");
      setTimeout(() => navigate("/login"), 2000); // Preusmeravanje na login
    } catch (error) {
      toast.error(error.response?.data?.message || "Neuspešna registracija!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sd__wrapper">
      {/* Notifikacije */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Logo */}
      <div className="sd__logo">
        <img
          src={require("../../assets/images/sdicon.png")}
          alt="SmartDeal Logo"
        />
      </div>

      {/* Naslov */}
      <div className="sd__title">Registracija</div>

      {/* Forma */}
      <form className="sd__form" onSubmit={handleSubmit}>
        <div className="sd__form-field">
          <FontAwesomeIcon icon={faUser} className="sd__icon" />
          <input
            type="text"
            name="username"
            placeholder="Korisničko ime"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="sd__form-field">
          <FontAwesomeIcon icon={faEnvelope} className="sd__icon" />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="sd__form-field">
          <FontAwesomeIcon icon={faKey} className="sd__icon" />
          <input
            type="password"
            name="password"
            placeholder="Lozinka"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="sd__form-field">
          <FontAwesomeIcon icon={faCheck} className="sd__icon" />
          <input
            type="password"
            name="confirmPassword"
            placeholder="Potvrdi lozinku"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <button className="sd__btn" type="submit" disabled={loading}>
          {loading ? "Registracija..." : "Registracija"}
        </button>
      </form>

      {/* Linkovi */}
      <div className="sd__links">
        <Link to="/login">Već imate nalog? Prijavite se</Link>
      </div>
    </div>
  );
};

export default Register;
